import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '@/util/helpers'

// initial state
const state = {
  tags: [],
  tagsPagination: {},
  tag: {}
}

// getters
const getters = {
  tags: state => state.tags,
  tagsPagination: state => state.tagsPagination,
  tag: state => state.tag
}

// actions
const actions = {
  getTags ({ state, commit }, args) {
    return Vue.axios.get(`/tags/`, {
      params: args.params,
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TAG_LIST, { response })
    })
  },
  getTag ({ state, commit }, args) {
    return Vue.axios.get(`/tags/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TAG, { response })
    })
  },
  createTag ({ state, commit }, args) {
    return Vue.axios.post(
      `/tags/`,
      args
    ).then((response) => {
      commit(types.RECEIVE_TAG, { response })
    })
  },
  saveTag ({ state, commit }, args) {
    return Vue.axios.put(
      `/tags/${state.tag.id}/`, state.tag, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TAG, { response })
    })
  },
  deleteTag ({ state, commit }, args) {
    return Vue.axios.delete(`/tags/${args.id}/`, {
      headers: args.headers || null
    }).then((response) => {
      commit(types.RECEIVE_TAG, { response })
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_TAG] (state, { response }) {
    state.tag = response.data.results
  },
  [types.RECEIVE_TAG_LIST] (state, { response }) {
    state.tags = response.data.results
    state.tagsPagination = helpers.pagination(response.headers)
  },
  [types.UPDATE_TAG_VALUE] (state, value) {
    state.tag = Object.assign(state.tag, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
